import React, { useEffect } from 'react';
import { useStore } from './store/useStore';
import { useScreenInit } from './useScreenInit.js';
import { ShopperApp } from './components/shopper/ShopperApp';
import { DispensaryApp } from './components/business/DispensaryApp';
export function App() {
  const {
    role,
    setRole
  } = useStore();
  const screenInit = useScreenInit();
  useEffect(() => {
    if (screenInit && Object.keys(screenInit).length > 0) {
      useStore.setState(screenInit);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <div className="min-h-screen flex flex-col bg-[#F4F5F6] font-sans text-[#252935]" data-id="element-0">
      {/* Persistent Top Bar */}
      <header className="bg-white border-b border-[rgba(37,41,53,0.12)] px-4 py-3 flex items-center justify-between sticky top-0 z-50" data-id="element-1">
        <div className="font-bold text-lg tracking-tight" data-id="element-2">
          Weedmaps <span className="text-[#00CDBE]" data-id="element-3">Stash</span>
        </div>
        <div className="flex bg-[#F4F5F6] p-1 rounded-full" data-id="element-4">
          <button onClick={() => setRole('Shopper')} className={`px-4 py-1.5 rounded-full text-sm font-medium transition-colors ${role === 'Shopper' ? 'bg-white shadow-sm text-[#252935]' : 'text-[#60646F] hover:text-[#252935]'}`} data-id="element-5">
            Shopper
          </button>
          <button onClick={() => setRole('Dispensary')} className={`px-4 py-1.5 rounded-full text-sm font-medium transition-colors ${role === 'Dispensary' ? 'bg-white shadow-sm text-[#252935]' : 'text-[#60646F] hover:text-[#252935]'}`} data-id="element-6">
            Dispensary
          </button>
        </div>
      </header>

      {/* Main Content Area */}
      <main className="flex-1 flex justify-center overflow-hidden" data-id="element-7">
        {role === 'Shopper' ? <div className="w-full max-w-[390px] bg-white h-full shadow-xl border-x border-[rgba(37,41,53,0.12)] overflow-y-auto" data-id="element-8">
            <ShopperApp data-id="element-9" />
          </div> : <div className="w-full max-w-6xl bg-[#F4F5F6] h-full overflow-y-auto" data-id="element-10">
            <DispensaryApp data-id="element-11" />
          </div>}
      </main>
    </div>;
}